import { render, staticRenderFns } from "./SVGArrowUp.vue?vue&type=template&id=f62f04c6&scoped=true&"
import script from "./SVGArrowUp.vue?vue&type=script&lang=js&"
export * from "./SVGArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f04c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f62f04c6')) {
      api.createRecord('f62f04c6', component.options)
    } else {
      api.reload('f62f04c6', component.options)
    }
    module.hot.accept("./SVGArrowUp.vue?vue&type=template&id=f62f04c6&scoped=true&", function () {
      api.rerender('f62f04c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGArrowUp.vue"
export default component.exports